module.exports = __webpack_public_path__ + "img/download.c74d81ac.svg";